import { EulerEvent } from "./types";

export type ValidatedData = {
  isValid: boolean;
  data: EulerEvent | null;
};

export function validateData(data: any, sportType: string): ValidatedData {
  if (data?.sportType === sportType) {
    return {
      isValid: true,
      data: data as EulerEvent,
    };
  }
  return {
    isValid: false,
    data: null,
  };
}
